import { render, staticRenderFns } from "./AssetOverlay.vue?vue&type=template&id=8c1378dc&"
import script from "./AssetOverlay.vue?vue&type=script&lang=js&"
export * from "./AssetOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports